import api from './api';

export const updateEvent = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = data.fileBase64 || '';
    let pictureBase64 = data.pictureBase64 || '';
    let keepExistingPicture = false;
    let keepExistingFile = false;
    
    // Eğer yeni bir resim seçilmemiş ve mevcut bir resim URL'si varsa
    if (!data.picture && (data.pictureUrl || data.existingPictureUrl)) {
      const pictureUrl = data.existingPictureUrl || data.pictureUrl;
      console.log('Mevcut resim korunacak:', pictureUrl);
      keepExistingPicture = true;
    } else if (!data.picture && !data.pictureUrl && !data.existingPictureUrl) {
      // Eğer resim seçilmemiş ve mevcut resim de yoksa, boş gönder
      pictureBase64 = '';
      keepExistingPicture = false;
      console.log('Resim seçilmedi ve mevcut resim yok, boş gönderiliyor');
    }

    // Eğer yeni bir dosya seçilmemiş ve mevcut bir dosya URL'si varsa
    if (!data.file && (data.fileUrl || data.existingFileUrl)) {
      const fileUrl = data.existingFileUrl || data.fileUrl;
      console.log('Mevcut dosya korunacak:', fileUrl);
      keepExistingFile = true;
    } else if (!data.file && !data.fileUrl && !data.existingFileUrl) {
      // Eğer dosya seçilmemiş ve mevcut dosya da yoksa, boş gönder
      fileBase64 = '';
      keepExistingFile = false;
      console.log('Dosya seçilmedi ve mevcut dosya yok, boş gönderiliyor');
    }

    // Convert picture to base64 if it's a File object
    if (data.picture && data.picture instanceof File) {
      // Validate image file
      if (!data.picture.type.startsWith('image/')) {
        throw new Error('Geçersiz resim formatı');
      }
      if (data.picture.size > 5 * 1024 * 1024) {
        throw new Error('Resim dosyası 5MB\'dan büyük olamaz');
      }

      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    // Convert file to base64 if it's a File object
    if (data.file && data.file instanceof File) {
      // Validate file size and type
      if (data.file.size > 10 * 1024 * 1024) {
        throw new Error('Dosya boyutu 10MB\'dan büyük olamaz');
      }

      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(data.file.type)) {
        throw new Error('Sadece PDF ve Word dosyaları kabul edilmektedir');
      }

      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Dosya okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Dosya okuma hatası:', error);
          reject(new Error('Dosya okuma sırasında bir hata oluştu'));
        };
      });
    }

    const payload = {
      guid: data.guid,
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      location: data.location,
      mapLocationCode: data.mapLocationCode,
      pictureBase64: pictureBase64,
      fileBase64: fileBase64,
      keepExistingPicture: keepExistingPicture,
      keepExistingFile: keepExistingFile,
      existingPictureUrl: data.existingPictureUrl || data.pictureUrl || '',
      existingFileUrl: data.existingFileUrl || data.fileUrl || ''
    };

    console.log('Güncellenecek etkinlik verisi:', {
      ...payload,
      pictureBase64: pictureBase64 ? '(base64 data present)' : '(no picture)',
      fileBase64: fileBase64 ? '(base64 data present)' : '(no file)'
    });

    const response = await api.post('/api/Event/UpdateEvent', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Event updated successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Network Error - No response received');
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};

export const getActiveEvents = async (params = {}) => {
  const defaultParams = {
    pageNum: "1",
    pageSize: "50",
    searchTerm: "",
    sortBy: "",
    startDate: "2024-03-20T22:10:19.398Z",
    endDate: "2030-03-20T22:10:19.398Z",
    ...params
  };

  try {
    const token = localStorage.getItem('token');
    const response = await api.post('/api/Event/GetActiveEvents', defaultParams, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const addEvent = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = '';
    let pictureBase64 = '';

    // Validate and convert picture to base64 if it exists
    if (data.picture) {
      // Validate image file
      if (!data.picture.type.startsWith('image/')) {
        throw new Error('Geçersiz resim formatı');
      }
      if (data.picture.size > 5 * 1024 * 1024) {
        throw new Error('Resim dosyası 5MB\'dan büyük olamaz');
      }

      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    // Validate and convert file to base64 if it exists
    if (data.file) {
      // Validate file size and type
      if (data.file.size > 10 * 1024 * 1024) {
        throw new Error('Dosya boyutu 10MB\'dan büyük olamaz');
      }

      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(data.file.type)) {
        throw new Error('Sadece PDF ve Word dosyaları kabul edilmektedir');
      }

      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Dosya okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Dosya okuma hatası:', error);
          reject(new Error('Dosya okuma sırasında bir hata oluştu'));
        };
      });
    }

    const payload = {
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      location: data.location,
      mapLocationCode: data.mapLocationCode,
      pictureBase64: pictureBase64,
      fileBase64: fileBase64
    };

    console.log('Sending event payload:', {
      ...payload,
      pictureBase64: pictureBase64 ? '(base64 data present)' : '(no picture)',
      fileBase64: fileBase64 ? '(base64 data present)' : '(no file)'
    });

    const response = await api.post('/api/Event/AddEvent', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Event added successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Network Error - No response received');
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};

export const deleteEvent = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post('/api/Event/DeleteEvent', { guid }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error deleting event:', error);
    throw error;
  }
};
